<template>
  <div class="store">
    <div class="content">
      <SearchNav ref="search" :isStoreSearch="true" :storeId="shopId" @search="searchChange" />
      <template v-if="store.shopId && store.openStatus">
        <StoreHeader @customer-service="customerService" :store="store" />
        <div class="store__tab">
          <el-tabs v-model="activeName" @click.native="linkTo">
            <el-tab-pane label="店铺首页" :name="`/store/${shopId}/homePage`"></el-tab-pane>
            <el-tab-pane label="全部商品" :name="`/store/${shopId}/goods`"></el-tab-pane>
            <el-tab-pane label="商家资质" :name="`/store/${shopId}/qualifications`"></el-tab-pane>
          </el-tabs>
        </div>
      </template>
    </div>
    <div v-if="store.shopId && !store.openStatus" class="empty">
      <img class="empty__logo" src="@/assets/store/store-close.png" />
      <div class="empty__text">你好，店铺已关闭</div>
    </div>
    <router-view @update-cart="$refs.search.updateCartNum()" v-if="store.shopId && store.openStatus" ref="storeInfo" />
  </div>
</template>

<script>
import * as api from '@/services';
// import { buyer_creat_session } from '@/services/chat';
import SearchNav from '@/components/SearchNav';
import StoreHeader from './components/StoreHeader';

export default {
  components: { SearchNav, StoreHeader },
  computed: {
    shopId() {
      return this.$route.params.id;
    }
  },
  provide() {
    return {
      storeRef: this,
      shopId: this.shopId
    };
  },
  watch: {
    $route: {
      handler({ path }) {
        this.activeName = path;
      },
      immediate: true
    }
  },
  data() {
    return {
      activeName: '',
      store: {}
    };
  },
  methods: {
    linkTo() {
      this.$router.push(this.activeName);
    },
    async getStoreInfo() {
      const store = await api.shop.getStoreInfo({ shopId: this.shopId });
      this.store = store;
    },
    // 修改搜索词
    searchChange() {
      if (this.$route.name !== 'allGoods') return;
      this.$nextTick(() => {
        this.$refs.storeInfo.getList();
      });
    },
    // 联系客服
    customerService() {
      this.sendSHOP();
    },
    openIm() {
      this.$store.dispatch('imDialogService/openDialog');
    },
    async sendSHOP() {
      const { groupId } = await api.shop.creatSession({
        storeId: this.store.storeId
      });
      this.$store.dispatch('imChatService/SET_CHAT_GID', groupId);
      this.$nextTick(() => {
        this.groupList.GroupListInit();
        this.groupChat.init();
      });
      this.openIm();
      // IM发送商品
      // this.$store.commit('imChatService/SET_WAITSENDCONFIG', {
      //   imgUrl:
      //     'https://91jkys-static-daily.oss-cn-hangzhou.aliyuncs.com/hydra-manage/36184be4d02811ebbb297edecb91bbd75170f753e9a72fc62bbedb508bff4255.jpeg',
      //   summary: '简介简介',
      //   type: 'merchandise',
      //   price: '1111',
      //   itemCode: '110',
      //   gid: groupId
      // });
    }
  },
  created() {
    this.getStoreInfo();
  }
};
</script>

<style lang="scss" scoped>
.store {
  &__header {
    height: 114px;
    margin: 12px 0;
    padding: 16px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    &__center,
    &__left,
    &__right {
      float: left;
    }
    &__center {
      padding: 0 180px 0 96px;
      width: 100%;
      height: 100%;
      overflow: hidden;
      &__name {
        font-size: 24px;
        font-weight: 500;
        color: #262626;
        line-height: 1;
      }
      &__active {
        margin-top: 12px;
        margin-bottom: 10px;
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        line-height: 1.5;
      }
      &__tags {
        line-height: 16px;
        .tag {
          display: inline-block;
          height: 16px;
          padding: 2px 4px;
          font-size: 12px;
          font-weight: 400;
          color: #ff8300;
          line-height: 1;
          background: #fff6ec;
          border-radius: 2px;
          & + .tag {
            margin-left: 8px;
          }
        }
      }
    }
    &__left {
      width: 80px;
      height: 100%;
      margin-left: -100%;
      &__logo {
        width: 80px;
        height: 80px;
      }
    }
    &__right {
      width: 170px;
      height: 100%;
      margin-left: -170px;
      &::before {
        display: inline-block;
        content: '';
        height: 100%;
        vertical-align: middle;
      }
      &__text {
        margin-left: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #1e8dff;
        line-height: 1;
      }
    }

    &__details {
    }
  }
  &__tab {
    ::v-deep .el-tabs__item {
      height: 48px;
      font-size: 16px;
      font-weight: 400;
      color: #262626;
    }
    ::v-deep .is-active {
      color: #1e8dff;
    }
  }
  .empty {
    padding: 238px 0;
    text-align: center;
    background: #f5f5f5;
    &__logo {
      width: 220px;
      height: 220px;
    }
    &__text {
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
    }
  }
  .vertical {
    vertical-align: middle;
  }
  ::v-deep .el-tabs__header {
    margin: 0;
  }
}
/deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 20px;
}
/deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
}
/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}
</style>
